import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from './index.module.scss';
import { recordTime } from './time';
import Link from '@/components/utils/Link2';
import { EFTooltipCheck, EFTooltipClose } from '@/components/UI/svg/My';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/getLocal';
import { isMembersFestival } from '@/utils/membersFestival';
import { signupCookie } from '@/utils/cookies/signupCookie';
import LoginFormModal from '@/components/LoginFormModal';

const useLang = () => {
    const { locale } = getLocal();

    const langText: Record<string, { [key: string]: string }> = {
        au: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 800 EcoCredits,Worth $40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        us: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 800 EcoCredits, Worth $40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        ca: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 800 EcoCredits, Worth $40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        cis: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 500 EcoCredits, Worth $25',
            button: 'Join Now',
            button1: 'Register without password',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        cn: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 500 EcoCredits, Worth $25',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        de: {
            desc: 'Sie erhalten 500 EcoCredits im Wert von 25 €',
            desc_1: 'Sie erhalten 800 EcoCredits im Wert von 40 €',
            button: 'Jetzt registrieren',
            button1: 'Anmelden/Registrieren ohne Passwort',
            register_tip: 'Bereits Mitglied? ',
            login: 'Einloggen',
        },
        en: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 500 EcoCredits, Worth $25',
            button: 'Join Now',
            button1: 'Password-free Login/Registration',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        es: {
            desc: 'Obtén 500 EcoCredits, con un valor de 25 €',
            desc_1: 'Obtén 800 EcoCredits, con un valor de 40 €',
            button: 'Únete ahora',
            button1: 'Inicio de sesión/registro sin contraseña',
            register_tip: '¿Ya tienes una cuenta? ',
            login: 'Inicia sesión',
        },
        eu: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 800 EcoCredits,Worth €40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        fr: {
            desc: "Obtenez 500 EcoCredits d'une valeur de 25 €",
            desc_1: "Obtenez 800 EcoCredits d'une valeur de 40 €",
            button: 'Rejoignez-nous maintenant',
            button1: 'Connexion sans mot de passe/Inscription',
            register_tip: 'Vous avez déjà un compte? ',
            login: 'Se connecter',
        },
        hk: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 500 EcoCredits, Worth €25',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        it: {
            desc: 'Ricevi 500 EcoCredits del valore di 25 €',
            desc_1: 'Ricevi 800 EcoCredits del valore di 40 €',
            button: 'Unisciti ora',
            button1: 'Accesso/registrazione senza password',
            register_tip: 'Hai già un account? ',
            login: 'Accedi',
        },
        jp: {
            desc: '500 エコポイント をゲット',
            desc_1: '800エコポイントをゲット',
            button: '今すぐ登録する',
            button1: 'パスワードなしでログイン／新規登録',
            register_tip: 'すでにアカウントをお持ちですか？ ',
            login: 'ログイン',
        },
        kr: {
            desc: '500 에코포인트(₩35,000 상당)를 받으세요',
            desc_1: '800 EcoCredits(56,000₩ 상당)를 받으세요',
            button: '지금 가입하기',
            button1: '비밀번호 없이 로그인/회원가입',
            register_tip: '기존 사용자이신가요? ',
            login: '로그인',
        },
        sa: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 500 EcoCredits, Worth €25',
            button: 'Join Now',
            button1: 'تسجيل الدخول/التسجيل دون كلمة مرور',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        tw: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 500 EcoCredits, Worth €25',
            button: 'Join Now',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        uk: {
            desc: 'Get 500 EcoCredits, Worth £25',
            desc_1: 'Get 800 EcoCredits,Worth £40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        za: {
            desc: 'Get 500 EcoCredits, Worth R500',
            desc_1: 'Get 800 EcoCredits,Worth R800',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        br: {
            desc: 'Ganhe 500 EcoCredits no valor de R$ 100',
            desc_1: 'Ganhe 800 EcoCredits no valor de R$ 40',
            button: 'Inscreva-se agora',
            button1: 'Registro/login sem senha',
            register_tip: 'Usuário existente? ',
            login: 'Faça login',
        },
        mx: {
            desc: 'Obtenga 500 EcoCredits con un valor de MXN 500',
            desc_1: 'Obtenga 800 EcoCredits con un valor de MXN 40',
            button: 'Únase ahora',
            button1: 'Inicio de sesión/Registro sin contraseña',
            register_tip: '¿Ya tienes una cuenta? ',
            login: 'Inicia sesión',
        },
        ph: {
            desc: 'Get 500 EcoCredits, worth  ₱1,500',
            desc_1: 'Get 500 EcoCredits, worth  ₱1,500',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
    };
    const copies = langText[locale] || langText['us'];

    return {
        t: (text: string) => copies[text] || text,
    };
};

const PopoverPanel = ({ showClose = true, isLogin, closePopover }: { showClose: boolean; isLogin: boolean; closePopover?: () => void }) => {
    const { locale, pathname } = getLocal();
    const { t } = useLang();
    const mfStatus = isMembersFestival(locale);

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const handleClick = () => {
        if (!isLogin) {
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div
            className={styled.popover}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            {showClose && (
                <div
                    className="close-buuton"
                    onClick={(e: any) => {
                        e.stopPropagation();
                        recordTime(locale);
                        closePopover && closePopover();
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'floating_close',
                            button_name: 'Close',
                            type: 'Authentication',
                        });
                    }}
                >
                    <EFTooltipClose />
                </div>
            )}
            <div className="desc-content">
                <EFTooltipCheck />
                <div className="text">{mfStatus === 0 ? t('desc_1') : t('desc')}</div>
            </div>
            <div
                className="button1"
                onClick={(e: any) => {
                    e.stopPropagation();
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'authentication_button',
                        type: 'Modal',
                        button_name: t('button1'),
                        url: 'none',
                    });
                    signupCookie?.({
                        entry_name: 'top floating_Password-free Register',
                        page_url: window.location.href,
                    });
                    closePopover && closePopover();
                    setShowLoginModal(true);
                    // window.location.href = `${window.location.origin}/${locale}/register/passwordless?redirect=${encodeURIComponent(window.location.href)}`;
                }}
            >
                {t('button1')}
            </div>
            <div
                className="button"
                onClick={(e: any) => {
                    e.stopPropagation();
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'authentication_button',
                        type: 'Redirect',
                        button_name: t('button'),
                        url: `${window.location.origin}/${locale}/register?redirect=${encodeURIComponent(window.location.href)}`,
                    });
                    signupCookie?.({
                        entry_name: 'top floating',
                    });
                    window.location.href = `${window.location.origin}/${locale}/register?redirect=${encodeURIComponent(window.location.href)}`;
                }}
            >
                {t('button')}
            </div>
            <div className="tip" onClick={handleClick}>
                {t('register_tip')}
                <Link
                    className="text-link"
                    href={`${window.location.origin}/${locale}/login?redirect=${encodeURIComponent(window.location.href)}`}
                    onClick={() => {
                        signupCookie?.({
                            entry_name: 'top floating',
                        });
                    }}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'authentication_button',
                        type: 'Redirect',
                        button_name: t('login'),
                        url: `https://www.ecoflow.com/${locale}/login?redirect=${encodeURIComponent(window.location.href)}`,
                    }}
                >
                    {t('login')}
                </Link>
            </div>
            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </div>
    );
};

export default PopoverPanel;
